import React, { Component, useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useForm, SubmitHandler } from "react-hook-form"
import {FieldHolder} from "@/components/holders/FieldHolder";

import { Editor } from 'react-draft-wysiwyg';
import '@/styles/wysiwyg/react-draft-wysiwyg.css';
import { EditorState, convertToRaw, convertFromRaw, convertFromHTML, ContentState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

import store from "@/redux/store";
import {storeBaseSetting2} from "@/reducers/Settings";

import { pdfjs, Document, Page } from 'react-pdf';
import {previewInvoice,uploadPDFTemplate, recreatePDF} from "@/reducers/Settings";

import {Accordion, AccordionBody, AccordionHeader, AccordionItem} from "@/components/accordion/index";

import { uploadFile, downloadFile, deleteFile } from "@/reducers/Files";
/*
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();
*/

export function PDFTemplates({...props}) {

    const setCoordinates = (x,y) => {
    // You don't need whitespace in here, I added it for readability
    // I would recommend using something like EmotionJS for this
    
        return {left: x+'px', top: y+'px'}
    }
    
    
    const [style, setStyle] = useState(   ); 
    const pdfdoc = useRef(null);
    const pdfdoc2 = useRef(null);
    const [currentPDf, setCurrentPDF] = useState();
    const inputFile = useRef(null);
    const { register, handleSubmit, watch, reset,    formState, setValue, getValues } = useForm({
        defaultValues: props.data.settings_pdf_templates,
        values: props.data.settings_pdf_templates
      })

      function getBase64(file) {
         var reader = new FileReader();
         reader.readAsDataURL(file);
         reader.onload = function () {
           
         };
         reader.onerror = function (error) {
           
         };
      }
      
         const onSubmit: SubmitHandler = (data) => {
          event.preventDefault();
          event.stopPropagation();

        store.dispatch( 
               uploadPDFTemplate({file: currentPDf, filedata:data})
               ).then((retData) => {
                   if(retData?.error) {
                       //store.dispatch( info(retData.payload.data.data.notification) );
                       store.dispatch( add({message: {...retData.payload.data.data.notification}, type: NotificationModel.NOTIFICATION_TYPE.ERROR}) );
                   }
          // use the file
          });    
          
      //        let settings = data.settings_invoice;
              //data["invoice~footer"] = {raw: htmlContent, html: draftToHtml(htmlContent)};
              //store.dispatch( storeBaseSetting2( {data: data, type: "invoice"} ) );

            
          return false;

          }
          
          const selectedFile=(event, name) => {
            
            
            inputFile.current.click();
            
            return false;
          }
          
          const onChangeFile = (event) => {
              event.stopPropagation();
              event.preventDefault();
              var file = event.target.files[0];
              setValue('pdftemplate~invoice', file.name);
              setValue('key', 'pdftemplate~invoice');
              setCurrentPDF(file);
              //this.setState({file}); /// if you want to upload latter
          }          

          const  onDocumentLoadSuccess = ((event) => {
//            if(pdfdoc && pdfdoc?.current && pdfdoc?.current !== null && pdfdoc?.current.pages.current && pdfdoc?.current.pages.current.length > 0) {
//                
//                pdfdoc.current.pages.current[0].addEventListener('click', handleClick);
//            }
          });

          const testMe = (event) => {
            
            
            
            
            //recreatePDF
            return; 
            store.dispatch( recreatePDF({x:event.layerY, y:event.layerX}) ).then((event => {
                
                let file = event.payload.data.data.file;
                setCurrentPDF(`data:application/pdf;base64,${file}`);
            }))
            
            return false;
          }
                    
    useEffect(() => {

        //setEditorState( EditorState.createWithContent(_getInitialHTML()) );
    return () => {

    };
  }, []);

  
      
    return (
    <div className="space-y-10 divide-y divide-gray-900/10 mt-8">
      <div className="grid grid-cols-2 gap-x-8 gap-y-8 md:grid-cols-12">
       <form className="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-4 px-5" onSubmit={handleSubmit(onSubmit)}>
            <div className="mt-1 space-y-8 pb-12 sm:space-y-0   sm:pb-0">
                  <input
                    id="key"
                    name="key"
                    type="hidden"
                    {...register("key")}
                    key={(props.data && props.data.key) ?? null} />


          </div>
        
        <div className="grid grid-cols-12 gap-3 cursor-pointer" onClick={(event) => {selectedFile(event, 'pdftemplate~invoice')}}>
            <FieldHolder colspan="6" smcolspan="6" label="Factuur template" id={"invoice_prefix_number"} error={props?.state?.error ?? null} >                
                  <div
                    type="text"
                    //disabled={true}
                    
                    data-dashlane-disabled-on-field="true"
                    
                    className="block w-full h-8 px-2 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  >{getValues(`pdftemplate~invoice`)}
                  </div>
                  <input type='file' id='file' ref={inputFile} style={{display: 'none'}} onChange={(event) => {onChangeFile(event)}}/>
            </FieldHolder>
            </div>
 



         <div className="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
            <Link to="" type="button" className="text-sm font-semibold leading-6 text-gray-900">
              Annuleren
            </Link>
            <button
              type="submit"
              className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Opslaan
            </button>
          </div>

        
        </form>
      <div className="col-span-8">
      {currentPDf &&
<Document ref={pdfdoc} file={(currentPDf)}  className="bg-gray-100 border-b p-1 flex items-center justify-center text-sm text-gray-600 gap-2 overflow-scroll h-screen relative" 
height={400} width={400}  onLoadSuccess={onDocumentLoadSuccess} scale={2.5} onMouseDown={() => {testMe(event)}}> 

 <Page onDragOver={(e) => { const ns = setCoordinates(e.nativeEvent.layerX, e.nativeEvent.layerY); setStyle(ns);}}
 ref={pdfdoc2}
                key="Page1"
                pageNumber={1}
                width={600}
                height={400}
                onMouseDown={() => {testMe(event)}}
                scale={1.1}
                className="none hide bg-gray-100 border-b p-1 flex items-center justify-center text-sm text-gray-600 gap-2 shadow-md relative" renderAnnotationLayer={false} renderTextLayer={false}

              >
              <div className="w-12 h-12 bg-red-900 absolute" draggable  style = {style} ></div>
              </Page>

</Document>
          }
      </div>
      </div>
      
      </div>
        
    )
}